<template>
  <Notification
    :description="$t('rc_notification_inactive_provider', { ConnectivityProvider: providerName })"
    v-bind="$attrs"
  />
</template>

<script setup>
import { computed } from 'vue'
import Notification from '@/components/productNotifications/Notification.vue'

import { useConnectivityProviderName } from '@/composables/useConnectivityProviderName'

const props = defineProps({
  extraParameters: { type: Object, default: () => ({}) },
})
const { providerName } = useConnectivityProviderName(computed(() => props.extraParameters.partnerId))
</script>
